<template>
    <div class="types_of_transport">
    <v-dialog v-model="dialogDelete" max-width="290">
        <v-card>
            <v-card-title class="headline">
                {{$t('msg_delete_type_transport')}}
            </v-card-title>

            <v-card-text>
                {{$t('msg_eliminar_invitacion_2')}}
            </v-card-text>

            <v-card-actions>
                <v-btn
                        color="primary"
                        @click="dialogDelete = false"
                >
                    No
                </v-btn>
                <v-spacer/>
                <v-btn
                        color="primary"
                        :loading="loadingAddTypeOfTransport"
                        @click="deleteTypeOfTransport"
                >
                    {{$t('Si')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- Diálogo con formulario -->
    <v-dialog v-model="dialogTypeOfTransport" max-width="350px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('type_transport') }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <!-- Nombre del Tipo de Transporte -->
            <v-text-field
                v-model="typeOfTransport.name"
                prepend-icon="forklift"
                :label="$t('nombre')"
                :error-messages="errores.name"
                :rules="[v => !!v || 'El nombre es requerido']"
                color="primary"
            ></v-text-field>
            <!-- Tipo de Carga -->
            <!-- <v-autocomplete
                v-model="typeChargeArea"
                prepend-icon="warehouse"
                name="typeChargeArea"
                item-text="name"
                item-value="id"
                :label="$t('type_landing_area')"
                :error-messages="errores.type"
                :items="typesChargeArea"
                :no-data-text="$t('no_resultados')"
            >
            </v-autocomplete> -->
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="dialogTypeOfTransport = false">
            {{ $t('cancelar') }}
          </v-btn>
          <v-btn v-if="update" color="primary" :loading="loadingAddTypeOfTransport" @click="updateTypeOfTransport">
            {{ $t('modificar') }}
          </v-btn>
          <v-btn v-else color="primary" :loading="loadingAddTypeOfTransport" @click="createTypeOfTransport">
            {{ $t('guardar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        <h2 class="subheading grey--text">{{$t('types_of_transport')}}</h2>
        <v-container class="my-5">
            <v-layout align-center justify-center fill-height>
            <v-btn
                    class="align-self-end"
                    color="primary"
                    @click="abrirDialogClientes">
                    {{ "+ " + $t('add_type_transport') }}
            </v-btn>
            </v-layout>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-layout class="my-4" align-center justify-center fill-height>
                <v-flex >
                    <v-card-title>
                        {{$t('types_of_transport')}}
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                :label="$t('Buscar')"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :loading="loadingTypesOfTransports"
                            :items="typesOfTransports"
                            :search="search"
                            class="elevation-1"
                            :rows-per-page-text="$t('filas_por_pagina')"
                            :no-data-text="$t('no_records_type_transports')"
                            :rows-per-page-items="[
                            {text: '10', value: 10},
                            {text: '20', value: 20},
                            {text: '25', value: 25},
                            {text: this.$t('todos'),
                            value: -1}]"
                    >
                        <template v-slot:items="props">
                            <td class="justify-center layout px-0">
                                <v-icon
                                        class="mr-2"
                                        @click="fillTypeOfTransport(props.item), errores = [], update = true, id_update = props.item.id"
                                    >
                                    edit
                                </v-icon>
                                <v-icon
                                        medium
                                        color="red"
                                        @click="dialogDelete = true, id_update = props.item.id"
                                >
                                    delete
                                </v-icon>
                            </td>
                            <td>{{ props.item.name }}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                            </v-alert>
                        </template>
                        <template v-slot:pageText="props">
                            {{props.rowsPerPage}}
                            {{$t('type_transport')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'

    Vue.use(VeeValidate)
    import { mapState, mapGetters} from 'vuex'

    export default {
        name: "types_of_transport",
        data: () => ({
            typesOfTransports: [],
            update: false,
            id_update: 0,
            errores: [],
            dialogTypeOfTransport: false,
            search: '',
            headers: [],
            loadingTypesOfTransports: false,
            valid: true,
            typeOfTransport: {
                name: ''
            },
            isLoading: false,
            id_empresa: '',
            loadingAddTypeOfTransport: false,
            typeChargeArea: '',
            dialogDelete: false,
            typesChargeArea: [
                {
                    id: 'ANDEN',
                    name: 'Andén'
                },
                {
                    id: 'ATADOS',
                    name: 'Área de Atados'
                },
                {
                    id: 'RAMPA',
                    name: 'Rampa'
                }
            ]
        }),
        beforeUpdate (){
            this.headers = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: this.$t('nombre'),
                    align: 'left',
                    sortable: true,
                    value: 'name'
                }
            ]
        },
        created: function () {
            this.get_extra_data()
        },
        computed: {
            ...mapState(['language']),
            ...mapGetters(['getProfile'])
        },
        methods: {
            getTypesOfTransports (){
                this.loadingTypesOfTransports = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/shipments/carrier-types/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    params: {
                        IdEmpresa: this.id_empresa,
                        is_active: true
                    }
                };
                axios(config)
                    .then(response => {
                        this.typesOfTransports = response.data
                        this.loadingTypesOfTransports = false
                    })
                    .catch(error => {
                        this.loadingTypesOfTransports = false
                        console.log(error)
                    })
            },
            get_extra_data (){
                this.loadingTypesOfTransports = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/auth/me',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.id_empresa = response.data.id_company
                        this.getTypesOfTransports()
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            abrirDialogClientes() {
                this.update = false
                this.id_update = 0
                this.errores = []
                this.dialogTypeOfTransport = true
                this.$refs.form.resetValidation()
                this.limpiarFormulario()
            },
            fillTypeOfTransport(item) {
                this.dialogTypeOfTransport = true
                this.typeOfTransport = {
                    name: item.name
                }
                this.typeChargeArea = item.type
            },
            createTypeOfTransport() {
                this.errores = []
                if (this.$refs.form.validate()) {
                    this.loadingAddTypeOfTransport = true
                    const config = {
                        method: 'post',
                        url: 'https://empresa-service.intrare.app/shipments/carrier-types/',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': this.language ,
                            'authorization': 'Token ' + store.getters.getToken
                        },
                        data: {
                            IdEmpresa: this.id_empresa,
                            name: this.typeOfTransport.name
                        }
                    };
                    axios(config)
                        .then(ok => {
                            this.loadingAddTypeOfTransport = false
                            this.$store.commit('snackbar_activate_true')
                            this.$store.commit('snackbar_change_message', this.$t('msg_type_transport'))
                            this.getTypesOfTransports()
                            this.dialogTypeOfTransport = false
                            this.limpiarFormulario()
                            setTimeout(this.clear, 3000);
                        })
                        .catch(error => {
                            this.loadingAddTypeOfTransport = false
                            if(error.response.status == 400
                                && typeof error.response.data == "object"
                                && error.response.data)
                                this.errores = error.response.data
                        })
                }
            },
            updateTypeOfTransport() {
                this.errores = []
                if (this.$refs.form.validate()) {
                    this.loadingAddTypeOfTransport = true
                    const config = {
                        method: 'patch',
                        url: 'https://empresa-service.intrare.app/shipments/carrier-types/' + this.id_update + '/',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': this.language ,
                            'authorization': 'Token ' + store.getters.getToken
                        },
                        data: {
                            IdEmpresa: this.id_empresa,
                            name: this.typeOfTransport.name
                        }
                    };
                    axios(config)
                        .then(ok => {
                            this.loadingAddTypeOfTransport = false
                            this.$store.commit('snackbar_activate_true')
                            this.$store.commit('snackbar_change_message', this.$t('msg_type_transport_updated'))
                            this.getTypesOfTransports()
                            this.dialogTypeOfTransport = false
                            this.limpiarFormulario()
                            setTimeout(this.clear, 3000);
                        })
                        .catch(error => {
                            this.loadingAddTypeOfTransport = false
                            if(error.response.status == 400
                                && typeof error.response.data == "object"
                                && error.response.data)
                                this.errores = error.response.data
                        })
                }
            },
            limpiarFormulario() {
                this.typeOfTransport = {
                    name: ''
                }
                this.typeChargeArea = ''
                this.valid = false
            },
            deleteTypeOfTransport () {
                this.errores = []
                this.loadingAddTypeOfTransport = true
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/shipments/carrier-types/' + this.id_update + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        IdEmpresa: this.id_empresa,
                        is_active: false
                    }
                };
                axios(config)
                    .then(ok => {
                        this.loadingAddTypeOfTransport = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_type_transport_deleted'))
                        this.getTypesOfTransports()
                        this.dialogDelete = false
                        this.limpiarFormulario()
                        setTimeout(this.clear, 3000);
                    })
                    .catch(error => {
                        this.loadingAddTypeOfTransport = false
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                    })
            },
            clear: function () {
                this.$validator.reset()
                this.$store.commit('snackbar_activate_false')
            }
        }
    }
</script>
